import React, { Component } from 'react';
import Cookies from 'js-cookie';
import {
  BrowserRouter as Router,
  Route,Switch,
  Redirect,
} from 'react-router-dom';
import { SnackbarProvider } from 'notistack';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';
import MobileDetect from 'mobile-detect';

import AdminNavigation from '../../components/AdminNavigation';
import AdminHeader from '../../components/AdminHeader';
import WeekView from '../../scenes/ProviderAdminSchedule/WeekView';
import DayView from '../../scenes/ProviderAdminSchedule/DayView';
import ProviderAdminPatients from '../../scenes/ProviderAdminPatients';
import ProviderAdminPractices from '../../scenes/ProviderAdminPractices';
import ProviderAdminAppointments from '../../scenes/ProviderAdminAppointments';
import ProviderAdminReferrals from '../../scenes/ProviderAdminReferrals';
import ProviderAdminConsultNotes from '../../scenes/ProviderAdminConsultNotes';
import ProviderAdminTrackingList from '../../scenes/ProviderAdminTrackingList';
import ProviderAdminSuperAdmin from '../../scenes/ProviderAdminSuperAdmin';
import NotificationDashboard from '../../scenes/NotificationDashboard';
import ProviderProfileMain from '../../scenes/ProviderProfile/ProviderProfileMain';
import ProviderAdminSuperAdminConsultNotes from '../../scenes/ProviderAdminSuperAdminConsultNotes';
import ProviderAdminSuperAdminAppointmentRequests from '../../scenes/ProviderAdminSuperAdminAppointmentRequests';
import ActivityReport from '../../scenes/ActivityReport';
import { CurrentUserProvider } from '../../contexts/CurrentUserContext';
import { CurrentPracticeProvider } from '../../contexts/CurrentPracticeContext';
import PatientProfilePage from '../../scenes/PatientProfilePage';
import * as api from '../../services/api/auth';
import ProviderGroupPatients from '../../scenes/ProviderGroupPatients';
import PaymentsList from '../../scenes/PaymentsList';

class ProvderAdmin extends Component {
  state = {
    isLoading: true,
    currentUser: null,
    currentPractice: null,
  };

  async componentDidMount() {
    const { history } = this.props;

    try {
      this.setState({ isLoading: true });

      const currentUser = await api.fetchCurrentUser();
      if (!currentUser.isPresent) {
        return history.push('/login');
      }

      if (!this.isMasquerading() && !currentUser.active) {
        return history.push('/activate');
      }

      const currentPractice = await api.fetchCurrentPractice();
      this.setState({ currentUser, currentPractice, isLoading: false });
    } catch {
      // If there was an error fetching the current user or current practice
      // we should not continue and redirect the user back to the home page.
      window.location.href = process.env.REACT_APP_HOMEPAGE_URL;
    }
  }

  isMasquerading = () => {
    return Cookies.get('is-masquerading');
  };

  onLogout = async () => {
    try {
      await api.logoutUser();
      localStorage.removeItem('pathRedirect');
      localStorage.removeItem('pathUrl');
      localStorage.removeItem('info');
    } finally {
      window.location.href = process.env.REACT_APP_HOMEPAGE_URL;
    }
  };

  detectMobile = url => {
    const md = new MobileDetect(window.navigator.userAgent);
    return md.mobile();
  };

  render() {
    const { isLoading, currentUser, currentPractice } = this.state;
    const { classes } = this.props;
    return (
      <>
        {isLoading ? (
          <div className={classes.loading}>
            <CircularProgress />
          </div>
        ) : (
          <CurrentUserProvider value={currentUser}>
            <CurrentPracticeProvider value={currentPractice}>
              <SnackbarProvider maxSnack={3}>
                <Router>
                  <Switch>
                    <Route
                      path="/admin"
                      render={({ match: { url } }) => (
                        <>
                          <AdminNavigation currentUser={currentUser} />
                          <AdminHeader onLogout={this.onLogout} />

                          <div
                            id="contentBox"
                            className={classes.adminContentWrapper}
                          >
                            <Route
                              path={url}
                              exact
                              render={() => <Redirect to={`${url}/schedule`} />}
                            />
                            <Route
                              path={`${url}/schedule`}
                              render={() => (
                                <Switch>
                                  <Route
                                    exact
                                    path={`${url}/schedule/weekview`}
                                    component={WeekView}
                                  />
                                  <Route
                                    exact
                                    path={`${url}/schedule/dayview`}
                                    component={DayView}
                                  />
                                  <Route
                                    exact
                                    path={`${url}/schedule`}
                                    render={() =>
                                      this.detectMobile(url) ? (
                                        <Redirect 
                                          to={`${url}/schedule/dayview`}
                                        />
                                      ) : (
                                        <Redirect 
                                          to={`${url}/schedule/weekview`}
                                        />
                                      )
                                    }
                                  />
                                </Switch>
                              )}
                            />
                            <Route
                              path={`${url}/patients`}
                              render={() => (
                                <>
                                  <Switch>
                                    <Route
                                      exact
                                      path={`${url}/patients`}
                                      component={ProviderAdminPatients}
                                    />
                                    <Route
                                      path={`${url}/patients/:patientId`}
                                      render={({ match: { url } }) => (
                                        <Route
                                          exact
                                          component={PatientProfilePage}
                                        />
                                      )}
                                    />
                                  </Switch>
                                </>
                              )}
                            />
                            <Route
                              path={`${url}/practices`}
                              component={ProviderAdminPractices}
                            />
                            <Route
                              path={`${url}/notifications`}
                              component={NotificationDashboard}
                            />
                            <Route
                              path={`${url}/appointments`}
                              component={ProviderAdminAppointments}
                            />
                            <Route
                              path={`${url}/referrals`}
                              component={ProviderAdminReferrals}
                            />
                            <Route
                              path={`${url}/consult-notes`}
                              component={ProviderAdminConsultNotes}
                            />
                            <Route
                              path={`${url}/tracking-list`}
                              component={ProviderAdminTrackingList}
                            />
                            <Route
                              path={`${url}/provider-profile`}
                              component={ProviderProfileMain}
                            />
                            <Route
                              path={`${url}/activity-report`}
                              component={ActivityReport}
                            />
                            {currentUser.admin && (
                              <>
                                <Route
                                  exact
                                  path={`${url}/admin`}
                                  component={ProviderAdminSuperAdmin}
                                />

                                <Route
                                  path={`${url}/admin/consult-notes`}
                                  component={
                                    ProviderAdminSuperAdminConsultNotes
                                  }
                                />
                                <Route
                                  path={`${url}/admin/appointment-requests`}
                                  component={
                                    ProviderAdminSuperAdminAppointmentRequests
                                  }
                                />
                                <Route
                                  path={`${url}/admin/addmember`}
                                  component={ProviderGroupPatients}
                                />
                                <Route
                                  path={`${url}/admin/paymentsList`}
                                  component={PaymentsList}
                                />
                              </>
                            )}
                          </div>
                        </>
                      )}
                    />
                  </Switch>
                </Router>
              </SnackbarProvider>
            </CurrentPracticeProvider>
          </CurrentUserProvider>
        )}
      </>
    );
  }
}

const styles = theme => ({
  loading: {
    height: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  adminContentWrapper: {
    width: 'calc(100% - 255px)',
    height: 'calc(100% - 75px)',
    float: 'left',
    marginTop: '100px',
    borderLeft: '1px solid rgba(0, 0, 0, 0.12)',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      height: 'auto',
      borderTop: '1px solid rgba(0, 0, 0, 0.12)',
      borderLeft: 'none',
      marginTop: '100px',
    },
  },
});

export default withStyles(styles)(ProvderAdmin);
